export const createCloneBlock = (block) => {
    let b = {
        block: block.key,
        settings: {},
    };

    if (block.parameters && block.parameters.length > 0) {
        block.parameters.forEach((parameter) => {
            if (b.settings[parameter.id] === undefined) {
                b.settings[parameter.id] = parameter.default;
            }
        });
    }

    return b;
};
